// extracted by mini-css-extract-plugin
export default {"alert":"styles_alert__q9bcg","centerAlert":"styles_centerAlert__qg7ZA","fullWidth":"styles_fullWidth__dRTdc"};